import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseMediator } from "../_types/case-mediator";

@Injectable({
    providedIn: 'root',
})
export class CasesMediatorsService extends Service<CaseMediator> {
    public override type = 'caseMediators';
    public override url = 'attendance/caseMediators';
}
